import * as AlertNotificationPrimitive from '@givebutter/primitives/alert-notification';
import styled from 'styled-components';

export const SdkInstructions = styled.p`
    display: initial;
`;

export const WidgetTypeImageContainer = styled.div`
    text-align: center;
`;

export const ConfigInstructions = styled.p`
    display: inline-block;
`;

export const AlertNotification = styled(AlertNotificationPrimitive.Root)`
    margin-bottom: 1rem;
`;
